import { useEffect, useState } from 'react';
import axios from 'axios';

export type AuthStatus = {
  connected: boolean;
  orgUrl: string | null;
  orgName: string | null;
  orgEdition: string | null;
  orgType: 'production' | 'sandbox' | null;
  username: string | null;
  role: 'consultant' | 'client-admin' | null;
};

export function useAuthStatus() {
  const [status, setStatus] = useState<AuthStatus | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get<AuthStatus>('/api/auth/status', { withCredentials: true })
      .then((res) => {
        if (!cancelled) setStatus(res.data);
      })
      .catch(() => {
        if (!cancelled)
          setStatus({
            connected: false,
            orgUrl: null,
            orgName: null,
            orgEdition: null,
            orgType: null,
            username: null,
            role: null,
          });
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { status, loading };
}
